import { Link } from "react-router-dom";
import { Mail, ArrowUpRight } from "lucide-react";

const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_sriman-enterprise/artifacts/ng31c679_image.png";

export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-[#020409] border-t border-white/5"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-20 md:py-24">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3">
              <span className="h-11 w-11">
                <img
                  src={LOGO_URL}
                  alt="Sriman Solutions"
                  className="h-full w-full object-contain"
                />
              </span>
              <div>
                <div className="font-display text-white text-lg tracking-tight">
                  Sriman Solutions
                </div>
                <div className="font-mono text-[10px] text-slate-500 tracking-[0.28em] uppercase">
                  Grow Together
                </div>
              </div>
            </div>
            <p className="mt-8 text-slate-400 text-sm leading-relaxed max-w-md">
              Enterprise-grade software, AML/KYC compliance, autonomous AI
              sales infrastructure and secure business process services —
              engineered for institutions that cannot compromise on privacy or
              control.
            </p>
            <a
              href="mailto:Info@srimansolutions.com"
              data-testid="footer-email-link"
              className="mt-8 inline-flex items-center gap-2 text-white text-sm border-b border-white/20 hover:border-red-500 hover:text-red-400 transition-colors pb-1"
            >
              <Mail size={14} />
              Info@srimansolutions.com
            </a>
          </div>

          <div className="md:col-span-2">
            <div className="overline mb-5">Company</div>
            <ul className="space-y-3 text-sm">
              <li>
                <Link
                  to="/"
                  data-testid="footer-home-link"
                  className="text-slate-400 hover:text-white transition-colors"
                >
                  Home
                </Link>
              </li>
              <li>
                <Link
                  to="/products"
                  data-testid="footer-products-link"
                  className="text-slate-400 hover:text-white transition-colors"
                >
                  Products
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  data-testid="footer-about-link"
                  className="text-slate-400 hover:text-white transition-colors"
                >
                  About
                </Link>
              </li>
              <li>
                <Link
                  to="/contact"
                  data-testid="footer-contact-link"
                  className="text-slate-400 hover:text-white transition-colors"
                >
                  Contact
                </Link>
              </li>
              <li>
                <Link
                  to="/partner"
                  data-testid="footer-partner-link"
                  className="text-slate-400 hover:text-white transition-colors"
                >
                  Partner with us
                </Link>
              </li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <div className="overline mb-5">Practices</div>
            <ul className="space-y-3 text-sm">
              <li>
                <Link
                  to="/services#aml"
                  className="text-slate-400 hover:text-white transition-colors"
                >
                  AML & KYC Compliance
                </Link>
              </li>
              <li>
                <Link
                  to="/services#ai"
                  className="text-slate-400 hover:text-white transition-colors"
                >
                  AI Sales Engines
                </Link>
              </li>
              <li>
                <Link
                  to="/services#it"
                  className="text-slate-400 hover:text-white transition-colors"
                >
                  Secure Software Engineering
                </Link>
              </li>
              <li>
                <Link
                  to="/services#bps"
                  className="text-slate-400 hover:text-white transition-colors"
                >
                  Business Process Services
                </Link>
              </li>
              <li>
                <Link
                  to="/services#eor"
                  className="text-slate-400 hover:text-white transition-colors"
                >
                  Employer of Record (EOR)
                </Link>
              </li>
              <li>
                <Link
                  to="/services#gis"
                  className="text-slate-400 hover:text-white transition-colors"
                >
                  GIS Mapping & Geospatial
                </Link>
              </li>
              <li>
                <Link
                  to="/services#rcm"
                  className="text-slate-400 hover:text-white transition-colors"
                >
                  Full-Cycle RCM
                </Link>
              </li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <div className="overline mb-5">Engage</div>
            <Link
              to="/contact"
              data-testid="footer-cta-button"
              className="group inline-flex items-center gap-2 text-white text-sm border border-white/15 hover:border-red-500 px-4 py-3 rounded-sm transition-colors"
            >
              Schedule a call
              <ArrowUpRight
                size={14}
                className="transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5"
              />
            </Link>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/5 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <div className="text-xs text-slate-500 font-mono tracking-wider">
            © 2022–2026 SRIMAN SOLUTIONS · ALL RIGHTS RESERVED
          </div>
          <div className="text-xs text-slate-500 font-mono tracking-wider">
            BOOTSTRAPPED · FOUNDER-LED · PRIVACY-FIRST
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
